import { history } from '@umijs/max';
import { currentUser as queryCurrentUser } from '@/services/ant-design-pro/api';
import type { AppInitialState } from '../types';

const loginPath = '/user/login';

export const useUserManagement = () => {
    const fetchUserInfo = async (): Promise<API.CurrentUser | undefined> => {
        try {
            const msg = await queryCurrentUser({
                skipErrorHandler: true,
            });
            return msg;
        } catch (_error) {
            history.push(loginPath);
        }
        return undefined;
    };

    const shouldFetchUserInfo = (pathname: string): boolean => {
        return ![loginPath, '/user/register', '/user/register-result'].includes(pathname);
    };

    const checkGoogle2FARequired = (currentUser?: API.CurrentUser): boolean => {
        return currentUser ? currentUser.google2faEnabled === false : false;
    };

    return {
        fetchUserInfo,
        shouldFetchUserInfo,
        checkGoogle2FARequired,
        loginPath,
    };
};
